module.exports = __webpack_public_path__ + "img/fast-backward.b0a2b0e2.svg";